module.exports = __webpack_public_path__ + "static/media/truck.d96bc566.svg";